import { Button } from '@timelyapp/react';
import InputDecorator from 'components/InputDecorator';
import InputWithDelay from 'components/InputWithDelay';
import React, { Component } from 'react';
import FontAwesome from 'react-fontawesome';

interface Props {
  buttonClass?: string;
  searchBoxClass?: string;
  value: string;
  onChange: (value: string, event: React.ChangeEvent<EventTarget> | null) => unknown;
}

interface State {
  expandSearch: boolean;
}

export class MemorySearchInput extends Component<Props, State> {
  static defaultProps = {
    value: '',
  };

  state = {
    expandSearch: false,
  };

  handleOnChange = (event: React.ChangeEvent<HTMLInputElement> | null | typeof undefined) => {
    const value = event ? event.target.value : '';
    this.props.onChange(value, event || null);
  };

  handleClear = () => {
    this.setState({ expandSearch: false });
    this.props.onChange('', null);
  };

  render() {
    const { value } = this.props;

    if (!this.state.expandSearch) {
      return (
        <Button
          onClick={() => this.setState({ expandSearch: true })}
          size="small"
          className={this.props.buttonClass}
        >
          <FontAwesome name="search" />
        </Button>
      );
    }

    return (
      <InputDecorator size="small" faIcon="search" onClear={this.handleClear} isClearable>
        <InputWithDelay
          autoFocus
          wait={350}
          size="small"
          name="searchQuery"
          onChange={this.handleOnChange}
          valueStateBuster={value === ''}
          value={value}
          className={this.props.searchBoxClass}
        />
      </InputDecorator>
    );
  }
}
